<div *ngIf="metas$ | async as metas">
  <p *ngIf="metas.length === 0" style="color:red;">No se encontraron metas para sus parametros de busqueda.</p>
  <table mat-table [dataSource]="metasFiltradas$ | async" class="mat-elevation-z8 full-width" #table
    *ngIf="metas.length > 0">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 192px;">
        <mat-checkbox (change)="checkTodos($event.checked, table._data)">
          Código
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let element;" style="width: 192px;">
        <mat-checkbox (change)="checked($event.checked, element)" [checked]="todos">
          {{element.codigo}}-{{element.id}}
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="categoria">
      <th mat-header-cell *matHeaderCellDef style="width: 180px;">
        <label style="text-align: left">Categoría<br>Subcategoría</label>
      </th>
      <td mat-cell *matCellDef="let element;" style="width: 180px;">
        <label>
          <strong>{{element.categoria.agrupador}}</strong>
          <br>
          {{element.categoria.nombre}}
        </label>
      </td>
    </ng-container>
    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef>Descripción</th>
      <td mat-cell *matCellDef="let element">
          {{(element.txtFR.length > 0 ? element.txtFR : element.txtEN.length > 0 ? element.txtEN : element.txtES) |
        HTMLEntitiesCleaner}}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50]" [showFirstLastButtons]="true">
</mat-paginator>